module.exports = [{
      plugin: require('/Users/jpb/code/clients/dan/okkro/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
